import { api, type Staff } from './api';

/**
 * 담당자 목록 — **세션당 한 번만** 부른다.
 *
 * 담당자 선택기가 여러 화면(접수 등록·수정·관리자)에 뜨는데, 화면을 열 때마다 부르면
 * 그만큼 왕복이 늘고 그 함수가 매번 콜드로 뜬다. 사내 계정은 수십 명이고 하루에 몇 번
 * 바뀌는 값이 아니라 캐시가 맞다 — 새 계정이 안 보이면 새로고침하면 된다.
 *
 * `lib/me.ts` 의 `loadMe` 와 같은 규약이다(로그아웃 때 함께 비운다).
 */
let cached: Promise<{ rows: Staff[]; teams: string[] }> | null = null;

export function loadStaff(): Promise<{ rows: Staff[]; teams: string[] }> {
  if (!cached) {
    cached = api.listStaff();
    // 실패한 약속을 물고 있으면 그 세션 내내 다시 시도하지 못한다.
    cached.catch(() => {
      cached = null;
    });
  }
  return cached;
}

/** 로그아웃·계정 변경 시 비운다. */
export function clearStaff(): void {
  cached = null;
}
